import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { updateCategoryIndex } from '../helpers/processEvents';
import { EVENT_CATEGORIES } from '../config/constants';


const EventCategory = () => {
	const { eventCategoryParam } = useParams();

	// useEffect to synchronize yearIndex with eventYearParam if necessary.
	useEffect(() => {
		// Determine the new category index, or default to 0.
		const categories = Array.from(EVENT_CATEGORIES.keys());
		const newCategoryIndex = categories.includes(eventCategoryParam) ? categories.indexOf(eventCategoryParam) : 0;
		updateCategoryIndex(newCategoryIndex);
	}, [eventCategoryParam]);

	return <Outlet />;
};

export default EventCategory;
